<template>
  <div id="Funds">
    <loading v-if="loadingRender"></loading>
    <net-pa-list-page-card
      title="لیست سپرده‌ها"
      description="از طریق این فرم می توانید لیست سپرده های خود را مشاهده کنید و عملیات های گردش و واریز وجه انجام  دهید"
      :show-back="true"
    >
      <template #toolbar>
        <net-pa-view-toggle
          :value="IsShowCard"
          aria-label="نوع نمایش سپرده‌ها"
          @input="ShowCard"
        ></net-pa-view-toggle>
        <ul
          class="nav nav-tabs netpa-list-page-header__tabs card-header-tabs"
          id="myTab"
          role="tablist"
          dir="rtl"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              id="Detail-tab"
              data-toggle="tab"
              href="#Detailtab"
              role="tab"
              aria-controls="Detailtab"
              aria-selected="true"
              >سپرده‌های خودم</a
            >
          </li>
          <li class="nav-item" v-if="$session.get('CustCode') == 801">
            <a
              class="nav-link"
              id="Logo-tab"
              data-toggle="tab"
              href="#Logotab"
              role="tab"
              aria-controls="Settingtab"
              aria-selected="false"
              >سپرده‌های وابسته</a
            >
          </li>
        </ul>
      </template>

      <div class="tab-content text-right p-3" id="Controler">
              <div class="tab-pane fade show active" id="Detailtab" role="tabpanel" aria-labelledby="Detail-tab">
                <div class="container mt-3 mb-3">
                  <div class="row funds-filter-row">
                    <div class="col-auto col-12 funds-filter-col">
                      <net-pa-filter-dropdown
                        button-id="dropdownMenuButton"
                        label="فیلتر سپرده‌ها"
                      >
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetItemCard(false);
                              $ResetTimer();
                            "
                            >سپرده‌های دارای مانده
                            <i v-if="selectedBedehi && selectedAllBedehi == false" class="fas fa-check text-success"></i>
                          </a>
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetItemCard(true);
                              $ResetTimer();
                            "
                            >همه سپرده‌ها
                            <i v-if="selectedAllBedehi && selectedBedehi == false" class="fas fa-check text-success"></i>
                          </a>
                      </net-pa-filter-dropdown>
                    </div>
                  </div>
                  <div
                    v-if="hasOwnFunds && IsShowCard"
                    class="row account-cards-grid"
                  >
                    <div
                      class="col-12 col-md-6 col-xl-4 account-card-col h-100"
                      v-for="(item, index) in CardItem"
                      :key="index"
                    >
                      <div class="card Netpa-Shadow border-0 mb-3 costom-card" dir="rtl">
                        <div class="row border-bottom">
                          <div class="text-right col-12">
                            <router-link
                              title="گردش سپرده"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblAzaIdAccount: item.wwwtblAzaId,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                },
                              }"
                              ><span class="fas fa-list text-warning" style="font-size: 16px"></span
                            ></router-link>
                            <a
                              v-if="$session.get('CustCode') != 868 && $session.get('CustCode') != 886"
                              data-toggle="modal"
                              data-target="#Modal-Mobile"
                              @click="OpenDetail(index)"
                              title="جزئیات سپرده"
                              ><span class="fas mx-2 fa-info-circle text-primary Pointer" style="font-size: 15px"></span
                            ></a>
                            <a
                              v-else
                              data-toggle="modal"
                              data-target="#Modal-Mobile"
                              @click="OpenDetail(index)"
                              title="جزئیات سپرده"
                              class="Pointer mr-2 badge badge-info text-light font-weight-normal px-2 py-1"
                              >جزئیات سپرده</a
                            >
                            <hr />
                          </div>
                          <div class="col-12 text-right account-card-body-main">
                            <div class="account-card-fields">
                              <div class="account-card-field-row">
                                <label class="account-card-field-row__label font-weight-bold">نوع سپرده :</label>
                                <span class="account-card-field-row__value font-weight-bold text-dark">{{ item.desNoe }}</span>
                              </div>
                              <div class="account-card-field-row">
                                <label class="account-card-field-row__label font-weight-bold">شماره سپرده :</label>
                                <span dir="rtl" class="account-card-field-row__value font-weight-bold text-dark">{{ item.vCode }}</span>
                              </div>
                              <div class="account-card-field-row">
                                <label class="account-card-field-row__label font-weight-bold">افتتاح سپرده :</label>
                                <span class="account-card-field-row__value font-weight-bold text-dark">{{ item.tarix }}</span>
                              </div>
                              <div class="account-card-field-row">
                                <label class="account-card-field-row__label font-weight-bold">شناسه واریز :</label>
                                <span class="account-card-field-row__value font-weight-bold text-dark">{{ item.shenaseVariz }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="account-card-balance-footer">
                          <div class="account-card-balance-block">
                            <div class="account-card-balance-row">
                              <label class="account-card-balance-row__label font-weight-bold">موجودی :</label>
                              <span class="account-card-balance-row__value font-weight-bold text-dark">{{
                                $Comma3ragham(Number(item.mande.replaceAll(',', '')) + Number(item.sumMabTaeedNaShode.replaceAll(',', '')))
                              }}</span>
                            </div>
                            <div class="account-card-balance-row">
                              <label class="account-card-balance-row__label font-weight-bold">قابل برداشت :</label>
                              <span class="account-card-balance-row__value font-weight-bold text-dark">{{
                                $Comma3ragham(Number(item.ghabelBardasht.replaceAll(',', '')))
                              }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-2 account-card-actions">
                          <div class="col-md-4 col-12" v-if="$session.get('AccessMenu').filter((x) => x.id == 7)[0].isMenu && item.isPayment && item.tblSarfaslTypeId != 6">
                            <a type="button" class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer" @click="Deposit(item)" style="font-size: 0.79rem !important">واریز</a>
                          </div>
                          <div class="col-md-4 col-12">
                            <router-link
                              title="گردش سپرده"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblAzaIdAccount: item.wwwtblAzaId,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                },
                              }"
                              class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              style="font-size: 0.79rem !important"
                              >گردش
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="ownFundsLoaded && !hasOwnFunds" class="row funds-empty-row">
                    <div class="col-12">
                      <div class="alert alert-warning w-100 text-center accounts-empty-alert">
                        سپرده‌ای برای نمایش یافت نشد
                      </div>
                    </div>
                  </div>
                  <div v-if="!IsShowCard && hasOwnFunds" class="row mt-2">
                    <div class="col-12 accounts-list-view">
                      <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config" :classes="classes">
                        <template slot="sort-asc-icon">
                          <i class="fa fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                          <i class="fa fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                          <i class="fa fa-sort"></i>
                        </template>
                        <template slot="action-slot" slot-scope="props">
                          <div class="accounts-list-actions">
                            <a
                              v-if="$session.get('AccessMenu').filter((x) => x.id == 7)[0].isMenu && props.row.isPayment && props.row.tblSarfaslTypeId != 6"
                              @click="Deposit(props.row)"
                              class="btn btn-outline-success accounts-list-btn Pointer"
                              >واریز</a
                            >
                            <router-link
                              title="گردش"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: props.row.id,
                                  wwwtblAzaIdAccount: props.row.wwwtblAzaId,
                                  wwwtblSarfaslTypeId: props.row.tblSarfaslTypeId,
                                },
                              }"
                              class="btn btn-outline-dark accounts-list-btn"
                            >
                              گردش
                            </router-link>
                          </div>
                        </template>

                        <template slot="empty-results">
                          <p class="text-right">اطلاعاتی یافت نشد</p>
                        </template>
                      </vue-bootstrap4-table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show" id="Logotab" role="tabpanel" aria-labelledby="Detail-tab">
                <div class="container mt-3 mb-3">
                  <div v-if="CardItemTaahodatSahebHesab.length > 0" class="row funds-filter-row">
                    <div class="col-auto col-12 funds-filter-col">
                      <net-pa-filter-dropdown
                        button-id="dropdownMenuButton2"
                        label="سپرده‌های وابسته"
                      >
                          <a
                            class="dropdown-item"
                            href="javascript:;"
                            v-for="item in groupBy"
                            :key="item.Id"
                            :id="item.wwwtblAzaId"
                            @click="
                              GetSahebHesab(item.wwwtblAzaId, false);
                              $ResetTimer();
                            "
                          >
                            {{ item.nameFamily }}</a
                          >
                          <hr />
                          <a
                            class="dropdown-item"
                            href="Javascript:;"
                            @click="
                              GetSahebHesab(0, true);
                              $ResetTimer();
                            "
                            >همه سپرده‌های وابسته
                            <i class="fas fa-check text-success"></i>
                          </a>
                      </net-pa-filter-dropdown>
                    </div>
                  </div>
                  <div v-else class="row">
                    <div class="col-12">
                      <div class="alert alert-warning w-100 text-center">در حال حاضر سپرده‌های وابسته شما صفر می‌باشد</div>
                    </div>
                  </div>
                  <div
                    v-if="hasDependentFundsList && IsShowCard"
                    class="row account-cards-grid"
                  >
                    <div
                      class="col-12 col-md-6 col-xl-4 account-card-col"
                      v-for="(item, index) in FilterCardItemTaahodatSahebHesab"
                      :key="index"
                    >
                      <div class="card border-0 mb-3 costom-card-sahebanhesab" dir="rtl">
                        <div class="row border-bottom">
                          <div class="text-right col-12">
                            <router-link
                              title="گردش سپرده"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                },
                              }"
                              ><span class="fas fa-list text-warning" style="font-size: 16px"></span
                            ></router-link>
                            <a data-toggle="modal" data-target="#Modal-Mobile" @click="OpenDetailSahebanHesab(index)" title="جزئیات سپرده"><span class="fas mx-2 fa-info-circle text-primary Pointer" style="font-size: 15px"></span></a>
                            <small class="text-dark float-left ml-3"
                              ><span class="fas fa-user text-success" style="font-size: 15px"></span>
                              {{ item.nameFamily }}
                            </small>
                            <hr />
                          </div>
                          <div class="col-12 text-right account-card-body-main">
                            <div class="account-card-fields">
                              <div class="account-card-field-row">
                                <label class="account-card-field-row__label font-weight-bold">نوع سپرده:</label>
                                <span class="account-card-field-row__value font-weight-bold text-dark">{{ item.desNoe }}</span>
                              </div>
                              <div class="account-card-field-row">
                                <label class="account-card-field-row__label font-weight-bold">شماره سپرده:</label>
                                <span dir="rtl" class="account-card-field-row__value font-weight-bold text-dark">{{ item.vCode }}</span>
                              </div>
                              <div class="account-card-field-row">
                                <label class="account-card-field-row__label font-weight-bold">افتتاح سپرده:</label>
                                <span class="account-card-field-row__value font-weight-bold text-dark">{{ item.tarix }}</span>
                              </div>
                              <div class="account-card-field-row">
                                <label class="account-card-field-row__label font-weight-bold">شناسه واریز:</label>
                                <span class="account-card-field-row__value font-weight-bold text-dark">{{ item.shenaseVariz }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="account-card-balance-footer">
                          <div class="account-card-balance-block">
                            <div class="account-card-balance-row">
                              <label class="account-card-balance-row__label font-weight-bold">موجودی:</label>
                              <span class="account-card-balance-row__value font-weight-bold text-dark">{{
                                $Comma3ragham(Number(item.mande.replaceAll(',', '')) + Number(item.sumMabTaeedNaShode.replaceAll(',', '')))
                              }}</span>
                            </div>
                            <div class="account-card-balance-row">
                              <label class="account-card-balance-row__label font-weight-bold">قابل برداشت:</label>
                              <span class="account-card-balance-row__value font-weight-bold text-dark">{{
                                $Comma3ragham(Number(item.ghabelBardasht.replaceAll(',', '')))
                              }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-2 account-card-actions">
                          <div class="col-md-4 col-12" v-if="$session.get('AccessMenu').filter((x) => x.id == 7)[0].isMenu && item.isPayment">
                            <a type="button" class="btn btn-outline-success custom-class NetPa-btn mb-1 w-100 no-wrap Pointer" @click="Deposit(item)" style="font-size: 0.79rem !important">واریز</a>
                          </div>
                          <div class="col-md-4 col-12">
                            <button
                              v-if="$session.get('AccessMenu').filter((x) => x.id == 13)[0].isMenu"
                              type="button"
                              class="btn btn-outline-danger custom-class NetPa-btn mb-1 w-100 no-wrap"
                              :disabled="item.ghabelBardasht <= 0"
                              :class="item.ghabelBardasht <= 0 ? 'btn-secondary text-dark disabled' : ''"
                              @click="debtor(item)"
                              style="font-size: 0.79rem !important"
                            >
                              برداشت
                            </button>
                            <button type="button" class="d-none" id="debtor" data-toggle="modal" data-target="#Modal-light"></button>
                          </div>
                          <div class="col-md-4 col-12">
                            <router-link
                              title="گردش سپرده"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: item.id,
                                  wwwtblSarfaslTypeId: item.tblSarfaslTypeId,
                                  wwwtblAzaIdAccount: item.wwwtblAzaId,
                                },
                              }"
                              class="btn btn-outline-dark custom-class NetPa-btn mb-1 w-100 no-wrap"
                              style="font-size: 0.79rem !important"
                              >گردش
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="!IsShowCard && hasDependentFundsList" class="row mt-2">
                    <div class="col-12 accounts-list-view">
                      <vue-bootstrap4-table :rows="rows2" :columns="columns2" :config="config" :classes="classes">
                        <template slot="sort-asc-icon">
                          <i class="fa fa-sort-up"></i>
                        </template>
                        <template slot="sort-desc-icon">
                          <i class="fa fa-sort-down"></i>
                        </template>
                        <template slot="no-sort-icon">
                          <i class="fa fa-sort"></i>
                        </template>
                        <template slot="action-slot" slot-scope="props">
                          <div class="accounts-list-actions">
                            <router-link
                              title="گردش"
                              :to="{
                                name: 'Turnover',
                                params: {
                                  TaahodatId: props.row.id,
                                  wwwtblAzaIdAccount: props.row.wwwtblAzaId,
                                  wwwtblSarfaslTypeId: props.row.tblSarfaslTypeId,
                                },
                              }"
                              class="btn btn-outline-dark accounts-list-btn"
                            >
                              گردش
                            </router-link>
                          </div>
                        </template>
                        <template slot="empty-results">
                          <p class="text-right">اطلاعاتی یافت نشد</p>
                        </template>
                      </vue-bootstrap4-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </net-pa-list-page-card>

    <modal-custom>
      <template v-slot:ContentModalLight>
        <debtor v-if="$store.state.renderComponent" :TaahodatId="taahodatId"></debtor>
      </template>
      <template v-slot:HeaderModalInfo>
        <span>
          <i class="fas fa-info-circle text-dark mx-2" style="font-size: 16 !important"></i>
          <span style="font-size: 16 !important" class="text-light font-weight-bold">جزئیات سپرده</span></span
        >
      </template>
      <template v-slot:ContentModalMobile>
        <div class="container-fluid">
          <div v-if="detailInModal != null" class="row p-3 rounded" style="background: #343a40">
            <div class="col-12 text-right">
              <h6 class="font-weight-bold text-right" style="font-size: 14px">
                <i class="fas fa-money-check ml-2" style="font-size: 14px"></i>
                {{ CardItem[detailInModal].desNoe }}
              </h6>
            </div>
            <!-- <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-success"></i> نوع سپرده: <span class="text-dark" style="font-size:15px !important"> {{CardItem[detailInModal].desNoe}}</span></div> -->
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>شماره سپرده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].vCode }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مانده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mande) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ افتتاح سپرده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].tarix }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ شروع شارژ:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItem[detailInModal].tarixShoroAghsat }}</span>
            </div>

            <div class="col-1 my-2"></div>
            <div class="col-10 border border-bottom my-2"></div>
            <div class="my-2"></div>
            <div class="col-12 text-right mt-2">
              <h6 class="font-weight-bold text-right" style="font-size: 14px"><i class="fas fa-ban ml-2" style="font-size: 14px"></i> مسدودی ها</h6>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghSood) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i> مسدودي بابت دريافت تسهيلات:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateDarTashilat) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودي بابت معرفی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi) }}</span>
            </div>
            <!-- <div class="col-6 "></div>
                                <div class="col-1"></div>
                                <div class="col-10 border border-bottom mt-2"></div>
                                <div class="col-1"></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i> امتیاز وام: <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i>امتیاز سپرده:  <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div> -->
          </div>
          <div v-if="detailInModalSahebHesab != null" class="row p-3 rounded" style="background: #343a40">
            <div class="col-12 text-right">
              <h6 class="font-weight-bold text-right" style="font-size: 14px">
                <i class="fas fa-money-check ml-2" style="font-size: 14px"></i>
                {{ CardItem[detailInModalSahebHesab].desNoe }}
              </h6>
            </div>
            <!-- <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-success"></i> نوع سپرده: <span class="text-dark" style="font-size:15px !important"> {{CardItem[detailInModal].desNoe}}</span></div> -->
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>شماره سپرده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].vCode }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>مانده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mande) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ افتتاح سپرده:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tarix }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-success"></i>تاریخ شروع شارژ:
              <span class="text-light" dir="rtl" style="font-size: 15px !important"> {{ CardItemTaahodatSahebHesab[detailInModalSahebHesab].tarixShoroAghsat }}</span>
            </div>

            <div class="col-1 my-2"></div>
            <div class="col-10 border border-bottom my-2"></div>
            <div class="my-2"></div>
            <div class="col-12 text-right mt-2">
              <h6 class="font-weight-bold text-right" style="font-size: 14px"><i class="fas fa-ban ml-2" style="font-size: 14px"></i> مسدودی ها</h6>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghSood) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i> مسدودي بابت دريافت تسهيلات:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghMasdodBabateDarTashilat) }}</span>
            </div>
            <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size: 15px !important">
              <i class="fas fa-square ml-2 text-warning"></i>مسدودي بابت معرفی:
              <span class="text-light" style="font-size: 15px !important"> {{ $Comma3ragham(CardItemTaahodatSahebHesab[detailInModalSahebHesab].mablaghMasdodBabateMoarefi) }}</span>
            </div>
            <!-- <div class="col-6 "></div>
                                <div class="col-1"></div>
                                <div class="col-10 border border-bottom mt-2"></div>
                                <div class="col-1"></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i> امتیاز وام: <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div>
                                <div class="col-md-6 col-12 mt-1 text-right mt-2" style="font-size:15px !important"><i class="fas fa-square ml-2 text-warning"></i>امتیاز سپرده:  <span class="text-light" style="font-size:15px !important"> {{$Comma3ragham(CardItem[detailInModal].mablaghMasdodBabateMoarefi)}}</span></div> -->
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import ModalCustom from '../Tools/ModalCustom.vue'
import NetPaListPageCard from '../Tools/NetPa/NetPaListPageCard.vue'
import NetPaViewToggle from '../Tools/NetPa/NetPaViewToggle.vue'
import NetPaFilterDropdown from '../Tools/NetPa/NetPaFilterDropdown.vue'
import Debtor from './Debtor.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import loading from '../Tools/NetPa/Loading.vue'

export default {
  data() {
    return {
      loadingRender: false,
      CardItem: [],
      CardItemTaahodatSahebHesab: 0,
      FilterCardItemTaahodatSahebHesab: null,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/TaahodatSahebHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      taahodatId: 0,
      detailInModal: null,
      detailInModalSahebHesab: null,
      selectedBedehi: true,
      selectedAllBedehi: false,
      IsTaahodatSahebHesab: false,
      IsShowCard: true,
      groupBy: null,
      rows: [],
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'نوع',
          name: 'desNoe',
        },
        {
          label: 'شماره',
          name: 'vCode',
        },
        {
          label: 'افتتاح سپرده',
          name: 'tarix',
        },
        {
          label: 'شناسه واریز ',
          name: 'shenaseVariz',
        },
        {
          label: 'موجودی',
          name: 'NewMande',
        },
        {
          label: 'قابل برداشت',
          name: 'NewghabelBardasht',
        },
        {
          label: 'عملیات ها',
          name: 'id',
          slot_name: 'action-slot',
          sort: false,
        },
      ],
      rows2: [],
      columns2: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'نوع',
          name: 'desNoe',
        },
        {
          label: 'شماره',
          name: 'vCode',
        },
        {
          label: 'مشخصات',
          name: 'nameFamily',
        },
        {
          label: 'افتتاح سپرده',
          name: 'tarix',
        },
        {
          label: 'شناسه واریز ',
          name: 'shenaseVariz',
        },
        {
          label: 'موجودی',
          name: 'NewMande',
        },
        {
          label: 'قابل برداشت',
          name: 'NewghabelBardasht',
        },
        {
          label: 'عملیات ها',
          name: 'id',
          slot_name: 'action-slot',
          sort: false,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped  ',
      },
    }
  },
  components: {
    NetPaListPageCard,
    NetPaViewToggle,
    NetPaFilterDropdown,
    ModalCustom,
    Debtor,
    VueBootstrap4Table,
    loading,
  },
  computed: {
    ownFundsLoaded() {
      return Array.isArray(this.CardItem)
    },
    hasOwnFunds() {
      return this.ownFundsLoaded && this.CardItem.length > 0
    },
    hasDependentFundsList() {
      return (
        this.IsTaahodatSahebHesab &&
        Array.isArray(this.FilterCardItemTaahodatSahebHesab) &&
        this.FilterCardItemTaahodatSahebHesab.length > 0
      )
    },
  },
  mounted() {
    this.GetItemCard(true)
    this.GetItemCardTaahodatSahebHesab()
  },
  methods: {
    GetSahebHesab(id, IsAll) {
      let info
      let list = []
      if (IsAll) {
        this.IsTaahodatSahebHesab = true
        this.FilterCardItemTaahodatSahebHesab = this.CardItemTaahodatSahebHesab
        for (let index = 0; index < this.FilterCardItemTaahodatSahebHesab.length; index++) {
          info = this.FilterCardItemTaahodatSahebHesab[index]
          info['NewMande'] = Number(this.FilterCardItemTaahodatSahebHesab[index].mande)+ Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode)
          info['NewghabelBardasht'] = Number(this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht)
          list.push(info)
        }
        this.rows2 = this.$FormatMablaghGrid(list)
      } else {
        this.IsTaahodatSahebHesab = true
        this.FilterCardItemTaahodatSahebHesab = this.CardItemTaahodatSahebHesab.filter((x) => x.wwwtblAzaId == id)
        for (let index = 0; index < this.FilterCardItemTaahodatSahebHesab.length; index++) {
          info = this.FilterCardItemTaahodatSahebHesab[index]
          info['NewMande'] = Number(this.FilterCardItemTaahodatSahebHesab[index].mande)+ Number(this.FilterCardItemTaahodatSahebHesab[index].sumMabTaeedNaShode)
          info['NewghabelBardasht'] = Number(this.FilterCardItemTaahodatSahebHesab[index].ghabelBardasht)
          list.push(info)
        }
        this.rows2 = this.$FormatMablaghGrid(list)
      }
    },
    ShowCard(status) {
      this.IsShowCard = status
    },
    GetItemCard(IsAll) {
      let info
      let list = []
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 2)
      this.DataAxiosRow.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        if (IsAll) {
          this.CardItem = data.filter((x) => x.tblSarfaslTypeId == 6)
          this.selectedBedehi = false
          this.selectedAllBedehi = true

          // for (let index = 0; index < data.length; index++) {
          //   info = data[index]
          //   info['NewMande'] = data[index].mande + data[index].sumMabTaeedNaShode
          //   info['NewghabelBardasht'] = data[index].ghabelBardasht + data[index].sumMabTaeedNaShode
          //   list.push(info)
          // }
          this.rows = this.$FormatMablaghGrid(this.CardItem)
        } else {
          this.CardItem = data.filter((x) => x.mande > 0 && x.tblSarfaslTypeId == 6)
          this.selectedBedehi = true
          this.selectedAllBedehi = false

          // for (let index = 0; index < data.length; index++) {
          //   info = data[index]
          //   info['NewMande'] = data[index].mande + data[index].sumMabTaeedNaShode
          //   info['NewghabelBardasht'] = data[index].ghabelBardasht + data[index].sumMabTaeedNaShode
          //   list.push(info)
          // }
          this.rows = this.$FormatMablaghGrid(this.CardItem)
        }
      })
    },
    GetItemCardTaahodatSahebHesab() {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 2)
      this.DataAxios_SahebHesab.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_SahebHesab)
        .then((data) => {
          this.CardItemTaahodatSahebHesab = data.filter((x) => x.tblSarfaslTypeId == 6)
          var result = this.CardItemTaahodatSahebHesab.reduce((unique, o) => {
            if (!unique.some((obj) => obj.wwwtblAzaId === o.wwwtblAzaId && obj.value === o.value)) {
              unique.push(o)
            }
            return unique
          }, [])
          this.groupBy = result
        })
        .finally(() => {
          if (this.$session.get('UserFromAccount')) {
            if (this.$session.get('UserFromAccount')[1] == true) {
              if (this.$session.get('UserFromAccount')[0] != this.$session.get('UserInfoNetPa').wwwtblAzaId) {
                document.getElementById('Logo-tab').click()
                document.getElementById(this.$session.get('UserFromAccount')[0]).click()
                this.$session.remove('UserFromAccount')
              } else {
                this.$session.remove('UserFromAccount')
              }
            }
          }
          this.loadingRender = false
        })
    },
    Deposit(Taahodat) {
      this.$router.push({
        name: 'Deposit',
        params: {
          TaahodatItem: Taahodat,
          wwwtblAzaIdAccount: Taahodat.wwwtblAzaId,
        },
      })
    },
    Payment() {
      this.$router.push({
        name: 'Debtor',
      })
    },
    debtor(row) {
      var GhebelBardasht = Number(row.ghabelBardasht.replace(/,/g, '').replace(/\./g, ''))
      this.$router.push({ name: 'Debtor', params: { TaahodatId: row.id, GhebelBardasht: GhebelBardasht } })
    },
    OpenDetail(index) {
      this.detailInModalSahebHesab = null
      this.detailInModal = index
    },
    OpenDetailSahebanHesab(index) {
      this.detailInModal = null
      this.detailInModalSahebHesab = index
    },
  },
}
</script>
<style scoped>
.border-warning {
  border-bottom: 1px dashed #ff9800 !important;
}

@media all and (max-width: 980px) {
  .custom-class {
    width: 100%;
    display: block;
  }
}

.btn-secondary:hover {
  outline: none !important;
  border: solid 1px gray !important;
}
</style>
<style>
#Funds .funds-filter-row {
  margin-bottom: 0;
}

#Funds .funds-empty-row {
  margin-top: 1rem;
}

#Funds .funds-empty-row .accounts-empty-alert {
  margin-bottom: 0;
}

#Funds .funds-filter-col {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

#Funds .netpa-list-page-filter-dropdown {
  width: fit-content;
  max-width: 100%;
}

#Funds .netpa-list-page-filter-btn {
  width: 190px;
  min-width: 190px;
  max-width: 190px;
  box-sizing: border-box;
}

#Funds .netpa-list-page-filter-btn__label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 767px) {
  #Funds .funds-filter-col {
    width: 100%;
  }

  #Funds .netpa-list-page-filter-dropdown {
    width: 100%;
  }

  #Funds .netpa-list-page-filter-btn {
    width: 100%;
    min-width: 0;
    max-width: none;
  }
}

#Funds .account-cards-grid {
  margin-left: -10px;
  margin-right: -10px;
  row-gap: 4px;
}

#Funds .account-card-col {
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 12px;
}

#Funds .costom-card,
#Funds .costom-card-sahebanhesab {
  padding: 16px 18px 14px;
  border-radius: 14px;
  margin-top: 0;
  margin-bottom: 0;
}

#Funds .costom-card .border-bottom > .col-12 > hr,
#Funds .costom-card-sahebanhesab .border-bottom > .col-12 > hr {
  margin-top: 0.35rem;
  margin-bottom: 0.25rem;
}

#Funds .account-card-body-main {
  padding-top: 0;
  margin-top: 0;
}

#Funds .account-card-fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-top: 0;
  margin-bottom: 0.65rem;
  padding-top: 0;
}

#Funds .account-card-field-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  text-align: right;
}

#Funds .account-card-field-row__label {
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
  color: #495057;
}

#Funds .account-card-field-row__value {
  text-align: left;
  word-break: break-word;
  min-width: 0;
}

#Funds .account-card-balance-footer {
  margin: 0;
  padding: 6px 0 10px;
  border-top: 1px solid #e8ecf1;
}

#Funds .account-card-balance-block {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  text-align: right;
  padding: 0;
  margin: 0;
}

#Funds .account-card-balance-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
}

#Funds .account-card-balance-row__label {
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
  color: #495057;
}

#Funds .account-card-balance-row__value {
  text-align: left;
  word-break: break-word;
  min-width: 0;
}

#Funds .account-card-actions {
  margin-top: 0.35rem;
}

#Funds .account-card-actions > [class*='col-'] {
  margin-bottom: 0.35rem;
}

#Funds .accounts-list-view .vbt-table-wrapper td {
  vertical-align: middle !important;
}

#Funds .accounts-list-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  justify-content: flex-start;
}

#Funds .accounts-list-btn {
  min-height: 34px;
  padding: 0.35rem 0.75rem;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  border-radius: 8px;
  white-space: nowrap;
}

#Funds .accounts-list-view .btn-outline-success.accounts-list-btn:hover,
#Funds .accounts-list-view .btn-outline-success.accounts-list-btn:focus {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

#Funds .accounts-list-view .btn-outline-dark.accounts-list-btn:hover,
#Funds .accounts-list-view .btn-outline-dark.accounts-list-btn:focus {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

#Funds .accounts-list-view .btn-outline-danger.accounts-list-btn:hover:not(:disabled),
#Funds .accounts-list-view .btn-outline-danger.accounts-list-btn:focus:not(:disabled) {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
</style>
